import React from 'react';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Stats } from './components/Stats';
import { Footer } from './components/Footer';
import { WhatsAppCta } from './components/WhatsAppCta';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-green-200 selection:text-green-900" data-id="element-0">
      <SEO data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Services data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <Process data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Stats data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
      <WhatsAppCta variant="floating" data-id="element-11" />
    </div>;
}